import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { RequestResponse } from "../model/dto/RequestResponse";
import { LoggerLayout } from "../model/LoggerLayout";

@Injectable()
export class LoggerLayoutsFacade {

    private _urlBase: string;
    private _httpClient: HttpClient;

    /**
     * Create a new instance of the class.
     */
    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    AddNewIncident(infoLog: any): Observable<RequestResponse<any>> {
        
        let body = JSON.stringify(infoLog)

        return this._httpClient.post<RequestResponse<LoggerLayout>>(this._urlBase + 'api/LoggerLayouts/Create', body, {
            headers: new HttpHeaders({'Content-Type':  'application/json'})
        });
    }

    GetAllLogger(): Observable<RequestResponse<any>> {
        return this._httpClient.get<RequestResponse<LoggerLayout>>(this._urlBase + 'api/LoggerLayouts/GetAll')
    }
}